import { createContext, type ReactNode, useContext } from 'react'

export const MobileLayoutContext = createContext(false)
export const useMobileLayout = () => useContext(MobileLayoutContext)

/**
 * The mobile stack row's header slot for its widget's own ⋮ menu. A widget's
 * WidgetActionsMenu portals itself into `element` (instead of sitting in the widget's
 * own header) and `claim`s the slot so the row drops its fallback menu; `extraItems` are
 * the row's own actions (Remove, mode switches…) appended to that one merged menu.
 */
export interface MobileWidgetMenuSlot {
  element: HTMLElement | null
  /** Returns the release function — call it from an effect and return it as the cleanup. */
  claim: () => () => void
  extraItems: (closeMenu: () => void) => ReactNode
}

export const MobileWidgetMenuSlotContext = createContext<MobileWidgetMenuSlot | null>(null)
export const useMobileWidgetMenuSlot = () => useContext(MobileWidgetMenuSlotContext)
